<script setup>
import useSharedData from "@/use/SharedData";
import {defineEmits, defineProps, ref, watch} from "vue";

const props = defineProps({
    value: [Number, String, Boolean, Object, Array],
    rules: Array,
    label: String,
    disabled: Boolean,
    readonly: Boolean,
    multiple: Boolean,
    notClearable: Boolean,
    returnObject: Boolean,
    items: Array,
});

const emit = defineEmits(["change", "input", "click"]);

const {loading, inputColor, backgroundColor} = useSharedData();

const item = ref(null);


watch(() => props.value, () => {
    if (props.value)
        item.value = props.value;
}, {immediate: true});


function input(value) {
    emit('input', value);
}

function change() {
    emit('change');
}

function click() {
    emit('click');
}
</script>

<template>
    <div>
        <v-autocomplete
            v-model="item"
            :label="label"
            :items="items"
            item-value="id"
            item-text="name"
            outlined
            dense
            :disabled="disabled"
            :loading="loading"
            :return-object="returnObject"
            :multiple="multiple"
            :readonly="readonly"
            :chips="multiple"
            :deletable-chips="multiple && !readonly"
            :clearable="!(readonly || notClearable)"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="input"
            @change="change"
            @click="click"
            :rules="rules"
        ></v-autocomplete>
        
        <input type="hidden"/>
    </div>
</template>

<style scoped>

</style>